import React from 'react';
import styled from 'styled-components';

import { HotelStars, Image } from '@lt/components';
import { Star } from '@lt/components/icons-react/userflow';

import { i18n } from '@lt/localization';
import logoPng from 'src/images/logo/logo.png';
import logoWebp from 'src/images/logo/logo.webp';

type Props = {
  reviewsCountText: string;
  className?: string;
  rating: number;
};

export const AppInformation = ({
  className,
  reviewsCountText,
  rating,
}: Props): JSX.Element => {
  const fullStarsCount = Math.floor(rating);
  const decimalPart = rating - fullStarsCount;
  return (
    <Container className={className}>
      <Logo src={logoWebp} fallback={logoPng} alt="Level.Travel logo" />
      <Content>
        <Title>{i18n.t('mobile_apps_banner.app_information.title')}</Title>
        <Description>
          {i18n.t('mobile_apps_banner.app_information.description')}
        </Description>
        <Data>
          {rating && (
            <>
              <Stars value={fullStarsCount} size={12} />
              <StyledStar height={12} viewBox={`0 0 ${25 * decimalPart} 24`} />
            </>
          )}
          {reviewsCountText && <Reviews>{reviewsCountText}</Reviews>}
        </Data>
      </Content>
    </Container>
  );
};

const Title = styled.p`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: #17181a;
`;

const Description = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #4d4d4d;
`;

const Container = styled.div`
  display: flex;
`;

const Logo = styled(Image)`
  margin: 0 8px 0 0;
  border: 1px solid #ebecf0;
  border-radius: 15px;
  width: 56px;
  height: 56px;
`;

const Content = styled.div`
  min-width: 130px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Data = styled.div`
  p:last-child {
    margin-left: 10px;
  }
  display: flex;
`;

const Stars = styled(HotelStars)`
  margin-right: 1px;

  & svg path {
    fill: #17181a;
    stroke: #17181a;
  }
`;

const Reviews = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #919499;
`;

const StyledStar = styled(Star).attrs(({ viewBox }) => ({ viewBox }))`
  path {
    fill: #17181a;
    stroke: #17181a;
  }
`;
